import { FC, ReactNode } from 'react';

type IconButtonProps = {
  size?: 'small' | 'medium' | 'large';
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  icon: ReactNode;
  disabled?: boolean;
};

export const IconButton: FC<IconButtonProps> = ({
  size = 'medium',
  onClick,
  icon,
  disabled = false,
}) => {
  const sizeMap = {
    small: '24px',
    medium: '32px',
    large: '40px',
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        width: sizeMap[size],
        height: sizeMap[size],
        border: 'none',
        background: 'transparent',
        cursor: disabled ? 'not-allowed' : 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        opacity: disabled ? 0.5 : 1,
      }}
    >
      {icon}
    </button>
  );
};
